import { render, staticRenderFns } from "./pushbuttonalerts.vue?vue&type=template&id=73d8e4ff&scoped=true"
import script from "./pushbuttonalerts.vue?vue&type=script&lang=js"
export * from "./pushbuttonalerts.vue?vue&type=script&lang=js"
import style0 from "./pushbuttonalerts.vue?vue&type=style&index=0&id=73d8e4ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d8e4ff",
  null
  
)

export default component.exports